/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Changes_IntroInputs */

const es_privacy_policy_changes_intro = /** @type {(inputs: Privacy_Policy_Changes_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nos reservamos el derecho de modificar esta Politica en cualquier momento. Para cambios significativos:`)
};

const en_privacy_policy_changes_intro = /** @type {(inputs: Privacy_Policy_Changes_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We reserve the right to modify this Policy at any time. For significant changes:`)
};

/**
* | output |
* | --- |
* | "We reserve the right to modify this Policy at any time. For significant changes:" |
*
* @param {Privacy_Policy_Changes_IntroInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_changes_intro = /** @type {((inputs?: Privacy_Policy_Changes_IntroInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Changes_IntroInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_changes_intro(inputs)
	return en_privacy_policy_changes_intro(inputs)
});
export { privacy_policy_changes_intro as "privacy_policy.changes.intro" }